import React from 'react';
import PropTypes from 'prop-types';

const Footer = props => {
  return (
    <footer>
      <div className="footer-contents">
        <div className="footer-text">
          z-emotion
          <br />
          Virtual Sports Styling
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {};

export default Footer;
